import React from 'react';

import MaintenancePage from './MaintenancePage';

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleMaintenance = this.handleMaintenance.bind(this);
  }

  componentDidMount() {
    window.addEventListener('app:maintenance', this.handleMaintenance);
  }

  componentWillUnmount() {
    window.removeEventListener('app:maintenance', this.handleMaintenance);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Keep diagnostics available to developers without exposing internals to shoppers.
    console.error('Storefront rendering error:', error, info?.componentStack);
  }

  handleMaintenance() {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) return <MaintenancePage />;
    return this.props.children;
  }
}

export default AppErrorBoundary;
